import { PHONE_REGIONS, resolveRegion, type PhoneRegion } from '~/config/localNumbers'

/**
 * Resolve the page's phone region from the route, or from an explicit override
 * (the footer pins `national`), and expose the display/tel pair.
 *
 * Route-deterministic so SSR and client agree (no hydration mismatch).
 */
export function useLocalPhone(regionOverride?: PhoneRegion) {
  const route = useRoute()
  const region = computed<PhoneRegion>(() => regionOverride ?? resolveRegion(route.path))
  const number = computed(() => PHONE_REGIONS[region.value])
  return {
    region,
    display: computed(() => number.value.display),
    tel: computed(() => number.value.tel),
  }
}
